import "babel-polyfill";
import "es6-promise";
import "isomorphic-fetch";
import React, { useEffect, useRef, useState } from "react";
import { DbotAppLight } from "dbot/src/app/DbotAppLight";
import { useDispatch, useSelector } from "react-redux";
import { isLaptopDevice } from "common/src/is-laptop-device";
import { ThemeProvider } from "styled-components";
import { addAndInitBlock } from "dbot/src/DbotActions";
import { GlobalStyle, AppWrapper, Wrapper, CustomizableDiv } from "./AppStyles";
import { fetchBlock } from "dbot/src/business/DbotHelperFunctions";
import { Progress } from "common/src/progressbar/Progressbar";
import { AcceptCookies } from "common/src/legal/AcceptCookies";
import { TopBar } from "common/src/topbar/TopBar";
import { getParamValueFromUrlSearch } from "static-content/view/api";
import { Notification } from "common/src/notification/Notification";

export const StandaloneDbot = () => {
  const scrollbar = useRef(null);
  const dispatch = useDispatch();
  const { dbotReducer, progress, modals, extra, notification } = useSelector((state) => state);
  const mediaUrl = window.OPSEEKER_CONFIG.CDN_URL + "/media";
  const topBar = window.GLOBAL_THEME.topBar;
  const client = window.OPSEEKER_CONFIG.CLIENT_PREFIX;
  const urlBlock = getParamValueFromUrlSearch("block");
  const userProfile = extra.profile ? extra.profile.toLowerCase() : extra.profile;
  useEffect(() => {
    console.log(window.OPSEEKER_CONFIG.BLOCK);
    dispatch(addAndInitBlock(fetchBlock(!!urlBlock ? urlBlock : window.OPSEEKER_CONFIG.BLOCK)));
  }, []);
  useEffect(() => {
    document.title = window.OPSEEKER_CONFIG.TAB_TITLE;
  }, []);
  return (
    <ThemeProvider
      theme={{
        themeGlobal: window.GLOBAL_THEME,
        dbotButton: "style1",
        embedded: true,
        client: client,
      }}
    >
      <AppWrapper>
        <GlobalStyle userProfile={userProfile} />
        {topBar && <TopBar />}
        <CustomizableDiv userProfile={userProfile} />
        <Wrapper topbar={topBar}>
          {topBar && <TopBar />}
          {window.OPSEEKER_CONFIG.SHOW_PROGRESS && (
            <Progress percentage={progress} withSymbol={window.OPSEEKER_CONFIG.PROGRESS_SYMBOL} />
          )}
          <DbotAppLight
            records={dbotReducer.records ? dbotReducer.records : []}
            mediaUrl={mediaUrl}
            scrollbar={isLaptopDevice(useState, useEffect) ? scrollbar : null}
            dispatch={dispatch}
            apis={dbotReducer.apis}
            appMode={""}
            buttonsDelay={dbotReducer.buttonsDelay}
            variables={extra}
            useRef={useRef}
            useState={useState}
            useEffect={useEffect}
          />
          <AcceptCookies dispatch={dispatch} modals={modals} backdrop={true} configEnabled={false} />
          {notification.dbotNotification && (
            <Notification
              notification={notification.dbotNotification}
              duration={5}
              key={notification.dbotNotification.type}
            />
          )}
        </Wrapper>
      </AppWrapper>
    </ThemeProvider>
  );
};
